import React from 'react';
import FontAwesome from 'react-fontawesome';
import '../../Styles/Home.css'


const Footer = () => {
  const [date,setDate] = React.useState(new Date().getFullYear());
    return (
        <>
            <footer className="page-footer font-small footerbackground">
                <div className="container">
                    <div className="row text-center d-flex justify-content-center pt-5 mb-3">
                        <div className="col-md-2 mb-3">
                            <h6 className="text-uppercase font-weight-bold">
                                <a aria-current="page" className="active" href="#home">Home</a>
                            </h6>
                        </div>
                        <div className="col-md-2 mb-3">
                        <h6 className="text-uppercase font-weight-bold">
                            <a href="#myTimeline">Experiences</a>
                        </h6></div>
                         <div className="col-md-2 mb-3">
                            <h6 className="text-uppercase font-weight-bold">
                                <a href="#projects">Projects</a>
                            </h6>
                        </div> 
                     
                            <div className="col-md-2 mb-3">
                            <h6 className="text-uppercase font-weight-bold">
                                <a href="#">Blogs</a>
                            </h6>
                        </div>
                      
                            
                            </div>
                    <hr className="rgba-white-light" style={{ margin: "0px 15%" }} />
                    <div className="row d-flex text-center justify-content-center mb-md-0 mb-4"><div className="col-md-8 col-12 mt-5">
                        <p >If something is important enough, even if the odds are stacked against you, you should still do it.</p>
                        <p >Want to connect with me,connect over any of the platform links given below</p>
                    </div>
                    </div>
                    <hr className="clearfix d-md-none rgba-white-light" style={{ margin: "10% 15% 5%" }} />

                    <div>
          <div className="col-md-4 mx-auto">
            <div className="social-links">
              <ul className="row">
                <li className="facebook">
                  <a target="_blank" href="https://www.facebook.com/profile.php?id=100008189806980"
                    ><FontAwesome className="fa fa-facebook" aria-hidden="true"/>
                  </a>
                </li>
                <li className="linkedin">
                  <a target="_blank" href="https://www.linkedin.com/in/abhinav-rai-6a7119154/"><FontAwesome className="fa fa-linkedin" aria-hidden="true"/> </a>
                </li>
                <li className="github">
                  <a target="_blank" href="https://github.com/Lyghtjr"><FontAwesome className="fa fa-github" aria-hidden="true"/>
                  </a>
                </li>
                <li className="instagram">
                  <a target="_blank" href="https://www.instagram.com/ultimate_disturbing_element/"><FontAwesome className="fa fa-instagram" aria-hidden="true"/> </a>
                </li>
                <li className="whatsapp">
                  <a target="_blank" href="https://wa.me/+918178486066"><FontAwesome className="fa fa-whatsapp" aria-hidden="true"/> </a>
                </li>
              </ul>
            </div>
          </div>
        </div>


</div>
                <div className="footer-copyright text-center py-3" >© {date} Copyright:
                <a href="/"> Abhinav </a>
                <br/>
                <p> Full-stack Developer || Mern Developer || Cross-Platform Developer <FontAwesome className="fas fa-cogs"/></p>
                </div>
               
                                                                                            
            </footer>
        </>
    )
}

export default Footer;